import { render } from "./LoaderComponent.vue?vue&type=template&id=73cdcc10&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=73cdcc10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cdcc10"]])

export default __exports__